import { Address } from '@common/components/address/address';
import { Community } from '@common/model/community';

export class JapanAddress extends Address {
    englishPrefecture: string;
    englishSublocalities: string;
    englishWard: string;
}

export class Prefecture {
    id: string;
    name: string;
    community?: Community;
    cities?: City[];
}

export class City {
    id: string;
    name: string;
    community?: Community;
    prefecture?: Prefecture;
}
